module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"showingXoutOf":"Showing {count} out of {total}","loadMore":"Load More"},"ar":{"showingXoutOf":"{count} من {total}","loadMore":"تحميل المزيد"}}')
  delete Component.options._Ctor
}
